import { baseApi } from "./baseApi";

const userApi: any = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    signIn: builder.mutation({
      query: (credentials) => ({
        url: "auth/sign_in",
        method: "POST",
        body: credentials
      }),
      transformResponse(apiResponse, meta) {
        return { apiResponse, meta };
      }
    }),
    getUserDetails: builder.query({
      query: () => "users/me"
    }),
    validateToken: builder.mutation({
      query: () => ({
        url: "auth/validate_token",
        method: "GET"
      }),
      transformResponse(apiResponse, meta) {
        return { apiResponse, meta };
      }
    }),
    validateUserToken: builder.query({
      query: () => "auth/validate_token"
    }),
    getUsers: builder.query({
      query: (params) => {
        let url = "users";

        url += "?";

        if (params.all_pages) {
          url += `all_pages=${params.all_pages}&`;
        }

        if (params.page) {
          url += `page=${params.page}&`;
        }
        if (params.page_size) {
          url += `page_size=${params.page_size}&`;
        }
        if (params.include_all) {
          url += `include_all=${params.include_all}&`;
        }
        if (params.role_type) {
          url += `role_type=${params.role_type}&`;
        }
        if (params.user_type) {
          params.user_type.forEach((type: any) => {
            url += `user_type[]=${type}&`;
          });
        }
        if (params.brand_id) {
          url += `brand_id=${params.brand_id}&`;
        }
        if (params.location_id) {
          url += `location_id=${params.location_id}&`;
        }
        if (params.partner_id) {
          url += `partner_id=${params.partner_id}&`;
        }
        if (params.name) {
          url += `name=${params.name}&`;
        }
        if (params.email) {
          url += `email=${params.email}&`;
        }
        if (params.mobile) {
          url += `mobile=${params.mobile}&`;
        }

        // Remove the trailing '&' if any
        if (url.endsWith("&")) {
          url = url.slice(0, -1);
        }

        // Remove the trailing '?' if any
        if (url.endsWith("?")) {
          url = url.slice(0, -1);
        }

        return url;
      }
    }),
    getUserById: builder.query({
      query: (userId) => `users/${userId}`
    }),
    createUser: builder.mutation({
      query: (userData) => ({
        url: "users",
        method: "POST",
        body: userData
      })
    }),
    updateUser: builder.mutation({
      query: (userData) => ({
        url: `users/${userData?.user?.id}`,
        method: "PUT",
        body: userData
      })
    }),
    deleteUser: builder.mutation({
      query: (userId) => ({
        url: `users/${userId}`,
        method: "DELETE"
      })
    }),
    assignUserRole: builder.mutation({
      query: ({ userId, roleData }) => ({
        url: `users/${userId}/roles`,
        method: "POST",
        body: roleData
      })
    }),
    assignUserRoles: builder.mutation({
      query: ({ userId, roleData }) => ({
        url: `users/${userId}/create_roles`,
        method: "POST",
        body: roleData
      })
    }),
    updateRole: builder.mutation({
      query: ({ userId, roleId, roleData }) => ({
        url: `users/${userId}/roles/${roleId}`,
        method: "PUT",
        body: roleData
      })
    }),
    deleteRole: builder.mutation({
      query: ({ userId, roleId }) => ({
        url: `users/${userId}/roles/${roleId}`,
        method: "DELETE"
      })
    }),
    transferBookings: builder.mutation({
      query: ({ userId, roleData }) => ({
        url: `users/${userId}/transfer_bookings`,
        method: "POST",
        body: roleData
      })
    }),
  })
});

export const {
  useSignInMutation,
  useGetUserDetailsQuery,
  useValidateUserTokenQuery,
  useValidateTokenMutation,
  useGetUsersQuery,
  useGetUserByIdQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useAssignUserRoleMutation,
  useAssignUserRolesMutation,
  useTransferBookingsMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation
} = userApi;
